/*
 *ajax
 */

//引入
import request from "../utils/request";
const baseURL = '/vote'
const loginURL = '/auth'
const api = {
    register: (data) => {
        return request({
            url: loginURL + "/xcxRegister",
            method: "post",
            data,
        });
    },
    //业主个人信息
    info: (params) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/get`,
            method: "get",
            params,
        });
    },
    //修改 
    update: (data) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/update`,
            method: "put",
            data,
        });
    },
    // 解除绑定
    delete: (openId) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/delete/${openId}`,
            method: "delete",
        });
    },
    //登录
    Login: (params) => {
        return request({
            url: loginURL + "/xcxlogin",
            method: "get",
            params,
        });
    },
    // openID
    openid: (jsCode) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/openId/${jsCode}`,
            method: "get",
        });
    },

    // 获取code地址
    codeUrl: () => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/getUrl`,
            method: "get",
        });
    },

    //获取tokenwxzjzhfwyzxx
    getToken: () => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/getToken`,
            method: "get",
        });
    },


}
export default api
